import { idType, locationType, selectItemType } from '@src/types';
import { PermissionsType } from '@hooks/useGetPermissions';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';
import { Column } from '@uikit/Tables/types';

const { rideTableColumns, standingOrderTableColumns } = TABLE_COLUMNS;

export const tableDataTitles = {
  rides: {
    tableTitles: rideTableColumns,
  },
  standingOrder: {
    tableTitles: standingOrderTableColumns,
  },
};

export type RidesTableName = keyof typeof tableDataTitles;

export type TypeRides = {
  title: string;
  hasPagination?: boolean;
  data: any;
  tableName: RidesTableName;
  isRide: boolean;
  isLoading: boolean;
  permissions: PermissionsType;
  addBtnTitle?: string;
  handleAddRide?: () => void;
  columnsOverride?: Column[];
  emptyText?: string;
};

export type TypeRidesTable = {
  data?: {
    authorizedNumber: string;
    memberIdNumber: string;
    callBackNumber: string;
    equipmentAddons: null;
    id: idType;
    member: string;
    modeOfTransport: string;
    rideOrderConfirmationCode: string;
    rideRequestDate: string;
    ridesSegments: Array<any>;
    ridesTags: Array<selectItemType>;
    schedulerAuthorizedContact: null;
    startDate?: string;
    endDate?: string;
    scheduledDays?: number[];
  };
  isRide: boolean;
  permissions: PermissionsType;
  dataTestId?: string;
  tableName: RidesTableName;
  isEmptyState?: boolean;
  columnsOverride?: Column[];
  emptyText?: string;
};

export type TypeRidesTableTitles = {
  data?: {
    authorizedNumber: string;
    memberIdNumber: string;
    callBackNumber: string;
    equipmentAddons: null;
    id: idType;
    member: string;
    modeOfTransport: string;
    rideOrderConfirmationCode: string;
    rideRequestDate: string;
    ridesSegments: Array<any>;
    ridesTags: Array<selectItemType>;
    schedulerAuthorizedContact: null;
  };
  isRide: boolean;
  permissions: PermissionsType;
};

export type ridesSegmentsType = {
  id: 0;
  standingOrderId: 0;
  contractor: string;
  payer?: string;
  payerName?: string;
  authorization: string;
  rideId: 0;
  orderingValue: 0;
  pickupLocations: locationType;
  dropOffLocation: locationType;
  dropOffLocationShortNote: string;
  pickupLocationShortNote: string;
  scheduledPickupTime: string;
  scheduledAppointmentTime: string;
  requestedWaitDuration: string;
  estimatedTripDuration: string;
  rideDate: string;
  miles: number;
  estMiles: number;
  callIndicator: boolean;
  user_defined_fwa_flag: boolean;
  status: string;
  pickUpContactPhone: string;
  dropOffContactPhone: string;
};

export const removeSeconds = (value?: string): string | undefined => {
  return value?.substring(5, -1);
};
